import { _ as i } from "./index.es108.js";
import { i as t } from "./index.es265.js";
var y = i, l = t;
function u(r, s, e) {
  var a = s(r);
  return l(r) ? a : y(a, e(r));
}
var o = u;
export {
  o as _
};
//# sourceMappingURL=index.es282.js.map
